import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";


const getModels = gql`
	query {
		getModels
	}
`;

export const entryCud = gql`
	mutation entryCud($data: JSONString!, $className: String!, $actionType: String!, $primaryKeys: JSONString) {
		entryCud(data: $data, className: $className, actionType: $actionType, primaryKeys: $primaryKeys){
			jsonObject
		}
	}
`

export const getModelData = gql`
	query getModelData($className: String!, $offset: Int = 1, $pageSize: Int = 10){
		getModelData(className: $className, offset: $offset, pageSize: $pageSize)
	}
`

export const getFkData = gql`
	query getFkData($model: String!, $column: String!){
		getFkData(model: $model, column: $column)
	}
`

export const getModelsQuery = compose(
	graphql(getModels,{
		options:{
			errorPolicy: "all",
			fetchPolicy: "network-only"
		},
		name:"getModelsQuery"
	}),
	graphql(entryCud, {
		options: {
			errorPolicy: "all",
			fetchPolicy: "network-only"
		},
		name: "entryCud"
	})
);


// WEBPACK FOOTER //
// ./src/views/admin/graph.js